import "./page-careers.scss";
import "../../../assets/src/eos/less/ui-components/bootstrap/modal-fail-country.scss";
import "../../js/core";
import setContactModalHandlers from "../../../assets/src/eos/js/modals/setContactModalHandlers";
import checkCountryModal from "../../../assets/src/eos/js/modals/checkCountryModal"

setContactModalHandlers('#modalHRContactForm');
checkCountryModal('#modalHRContactForm', 'Ukraine')
